import React, { useEffect, useState } from "react";
import { memo } from "react";
import { Main } from "./main/Loadable";

const ListNews = memo(() => {
  return <Main />;
});

export default ListNews;
